import "./portfolio.css";
import UploadIcon from "../../assets/upload.png";
import Modal from "../../Modal/Modal";
import ExperienceForm from "./ExperienceForm";
import { useState } from "react";
import EducationForm from "./EducationForm";
import InternshipForm from "./InternshipForm";
import ProjectForm from "./ProjectForm";
import { useEffect, useRef } from "react";
import { Plus, Pencil, Eye } from "lucide-react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Trash2 } from "lucide-react";
import axios from "axios";
import ClipLoader from "react-spinners/ClipLoader";
import { useParams } from "react-router-dom";
import DropdownActions from "../../components/DropdownActions";
import { ThreeDot } from "react-loading-indicators";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const buildEducationPayload = (formData) => {
  const token = localStorage.getItem("access_token");
  const formPayload = new FormData();
  formPayload.append("degree", formData.degree);
  formPayload.append("field_study", formData.field_study);
  formPayload.append("start_Year", formData.start_Year);
  formPayload.append("end_Year", formData.end_Year);
  formPayload.append("grade", formData.grade);
  formPayload.append("description", formData.description);
  if (formData.media) {
    formPayload.append("media", formData.media);
  }
  if (formData.skills && Array.isArray(formData.skills)) {
    formData.skills.forEach((skill) => {
      formPayload.append("skills", skill);
    });
  }
  return formPayload;
};

const Portfolio = () => {
  const token = localStorage.getItem("access_token");
  const { userId: id } = useParams();
  const [showExpModal, setShowExpModal] = useState(false);
  const [EducationModalOpen, setEducationModalOpen] = useState(false);
  const [editingEducationIndex, setEditingEducationIndex] = useState(null);
  const [editingEducationData, setEditingEducationData] = useState(null);
  const [educationList, setEducationList] = useState([]);
  const [showInternshipForm, setShowInternshipForm] = useState(false);
  const [editingInternship, setEditingInternship] = useState(null);
  const [internships, setInternships] = useState([]);
  const [showProjectForm, setShowProjectForm] = useState(false);
  const [editingProjectIndex, setEditingProjectIndex] = useState(null);
  const [projects, setProjects] = useState([]);
  const [editExperienceIndex, setEditExperienceIndex] = useState(null);
  const [editExperienceData, setEditExperienceData] = useState(null);
  const [experiences, setExperiences] = useState([]);
  const [editingProjectData, setEditingProjectData] = useState(null);
  const [resumeFile, setResumeFile] = useState([]);
  const [isUploading, setIsUploading] = useState(false);
  const [loadingPortfolio, setLoadingPortfolio] = useState(true);
  const [showLanguageModal, setShowLanguageModal] = useState(false);
  const [editLanguageIndex, setEditLanguageIndex] = useState(null);
  const [newLanguage, setNewLanguage] = useState("");
  const [editLanguageData, setEditLanguageData] = useState(null);
  const [languageInput, setLanguageInput] = useState("");
  const [languages, setLanguages] = useState([]);
  const fileInputRef = useRef(null);
  const [skills, setSkills] = useState([]);
  const [newSkill, setNewSkill] = useState("");
  const [showSkillModal, setShowSkillModal] = useState(false);
  const [editSkillIndex, setEditSkillIndex] = useState(null);
  const [editSkillData, setEditSkillData] = useState(null);
  const [reviews, setReviews] = useState([]);
  const [newReview, setNewReview] = useState("");
  const [showReviewModal, setshowReviewModal] = useState(false);
  const [editReviewIndex, setEditReviewIndex] = useState(null);
  const [editReviewData, setEditReviewData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showCV, setShowCV] = useState(false);
  const [cvUrl, setCvUrl] = useState("");
  const modalRef = useRef(null);

  const handleSaveInternship = (data) => {
    if (editingInternship) {
      setInternships((prev) =>
        prev.map((int) => (int === editingInternship ? data : int))
      );
    } else {
      setInternships((prev) => [...prev, data]);
    }

    setShowInternshipForm(false);
    setEditingInternship(null);
  };
  const handleSaveProject = (data, index = null) => {
    if (data?.id && index !== null) {
      setProjects((prev) => prev.map((proj, i) => (i === index ? data : proj)));
    } else {
      setProjects((prev) => [...prev, data]);
    }
    setShowProjectForm(false);
    setEditingProjectIndex(null);
    setEditingProjectData(null);
  };
  const convertFileToBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });

  const handleResumeUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const token = localStorage.getItem("access_token");
    const formData = new FormData();
    formData.append("cv_pdf", file);

    // Ensure languages & skills are included for initial POST
    if (skills && skills.length > 0) {
      formData.append("skills", JSON.stringify(skills));
    }
    if (languages && languages.length > 0) {
      formData.append("languages", JSON.stringify(languages));
    }

    try {
      setIsUploading(true);
      let existingPortfolio = null;

      try {
        const res = await axios.get(
          `${BASE_URL}/user/portfolio/personal-portfolio/`,
          {
            headers: { Authorization: `Bearer ${token}`, "x-api-key": process.env.REACT_APP_X_API_KEY },
          }
        );
        existingPortfolio = Array.isArray(res.data?.data)
          ? res.data.data[0]
          : res.data?.data;
      } catch (err) {
        if (err.response?.status !== 404) {
          throw err;
        }
      }

      let response;
      if (existingPortfolio) {
        response = await axios.patch(
          `${BASE_URL}/user/portfolio/personal-portfolio/`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data",
              "x-api-key": process.env.REACT_APP_X_API_KEY
            },
          }
        );
      } else {
        response = await axios.post(
          `${BASE_URL}/user/portfolio/personal-portfolio/`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data",
              "x-api-key": process.env.REACT_APP_X_API_KEY
            },
          }
        );
      }

      const cvUrl = response.data.cv_pdf || response.data.data?.cv_pdf;
      setResumeFile({ name: file.name, url: cvUrl });
    } catch (error) {
      console.error("Resume upload failed:", error.response?.data || error);
    } finally {
      setIsUploading(false);
    }
  };

  const handleAddLanguage = async () => {
    setLoading(true);
    try {
      const updatedLanguages = [...languages, newLanguage.trim()];
      const languageString = updatedLanguages.join(",");
      const response = await fetch(
        `${BASE_URL}/user/portfolio/personal-portfolio/`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            "x-api-key": process.env.REACT_APP_X_API_KEY
          },
          body: JSON.stringify({ language: languageString }),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to add language");
      }

      const data = await response.json();
      console.log("Language added:", data);

      setLanguages(updatedLanguages);
      setNewLanguage("");
      setEditLanguageData(null);
      setShowLanguageModal(false);
    } catch (error) {
      console.error("Add language failed:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleAddSkill = async () => {
    setLoading(true);
    try {
      const updatedSkills = [...skills, newSkill.trim()].join(",");
      const response = await fetch(
        `${BASE_URL}/user/portfolio/personal-portfolio/`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            "x-api-key": process.env.REACT_APP_X_API_KEY
          },
          body: JSON.stringify({ skills: updatedSkills }),
        }
      );

      if (!response.ok) throw new Error("Failed to add skill");

      setSkills((prev) => [...prev, newSkill.trim()]);
      setNewSkill("");
      setEditSkillData(null);
      setShowSkillModal(false);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleAddReview = async () => {
    if (!newReview.trim()) return;
    setLoading(true);

    try {
      const reviewList = newReview
        .split(",")
        .map((r) => r.trim())
        .filter((r) => r.length > 0);

      const addedReviews = [];
      for (const review of reviewList) {
        const res = await fetch(`${BASE_URL}/user/portfolio/review/`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            "x-api-key": process.env.REACT_APP_X_API_KEY
          },
          body: JSON.stringify({ review }),
        });

        if (!res.ok) throw new Error("Failed to add review");

        const data = await res.json();
        addedReviews.push(data.data);
      }

      setReviews((prev) => [...prev, ...addedReviews]);
      setNewReview("");
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  // Edit review
  const handleEditReview = async (updatedReviews) => {
    if (!updatedReviews.length) return;
    setLoading(true);
    try {
      const updatedList = [];
      for (let i = 0; i < updatedReviews.length; i++) {
        const reviewObj = updatedReviews[i];
        const existingReview = reviews[i];

        const formData = new FormData();
        formData.append("id", existingReview.id);
        formData.append("review", reviewObj.review);

        const res = await fetch(`${BASE_URL}/user/portfolio/review/`, {
          method: "PATCH",
          headers: {
            Authorization: `Bearer ${token}`,
            "x-api-key": process.env.REACT_APP_X_API_KEY
          },
          body: formData,
        });

        if (!res.ok) throw new Error("Failed to update review");

        const data = await res.json();
        updatedList.push(data.data);
      }

      setReviews(updatedList);
      setNewReview("");
      setEditReviewData(null);
      setshowReviewModal(false);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  // const handleDeleteReview = async (reviewId) => {
  //   setLoading(true);
  //   try {
  //     const res = await fetch(`${BASE_URL}/user/portfolio/review/`, {
  //       method: "DELETE",
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${token}`,
  //       },
  //       body: JSON.stringify({ id: reviewId }),
  //     });

  //     if (!res.ok) throw new Error("Failed to delete review");

  //     setReviews((prev) => prev.filter((r) => r.id !== reviewId));
  //   } catch (error) {
  //     console.error(error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleDeleteReview = async () => {
    if (reviews.length === 0) return;
    setLoading(true);
    try {
      const formData = new FormData();
      reviews.forEach((review) => formData.append("id", review.id));

      const res = await fetch(`${BASE_URL}/user/portfolio/review/`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          "x-api-key": process.env.REACT_APP_X_API_KEY
        },
        body: formData,
      });

      if (!res.ok) throw new Error("Failed to delete reviews");

      setReviews([]);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateLanguage = async (updatedLanguages) => {
    setLoading(true);
    try {
      const languageString = updatedLanguages.join(",");
      const response = await fetch(
        `${BASE_URL}/user/portfolio/personal-portfolio/`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            "x-api-key": process.env.REACT_APP_X_API_KEY
          },
          body: JSON.stringify({ language: languageString }),
        }
      );

      if (!response.ok) throw new Error("Failed to update languages");
      const data = await response.json();
      console.log("Languages updated:", data);
      setLanguages(updatedLanguages);
    } catch (error) {
      console.error("Update language failed:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleEditClick = (lang, index) => {
    setNewLanguage(languages.join(", "));
    setEditLanguageData(true);
    setEditLanguageIndex(index);
    setShowLanguageModal(true);
  };

  const handleEdit = () => {
    setNewReview(reviews.map((r) => r.review).join(", "));
    setEditReviewData(reviews);
    setEditReviewIndex(null);
    setshowReviewModal(true);
  };
  const handleDeleteClick = async () => {
    await handleUpdateLanguage([]);
    setLanguages([]);
  };

  const handleUpdateSkills = async (updatedSkills) => {
    setLoading(true);
    try {
      const skillsString = updatedSkills.join(",");
      const response = await fetch(
        `${BASE_URL}/user/portfolio/personal-portfolio/`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            "x-api-key": process.env.REACT_APP_X_API_KEY
          },
          body: JSON.stringify({ skills: skillsString }),
        }
      );

      if (!response.ok) throw new Error("Failed to update skills");

      const data = await response.json();
      console.log("Skills updated:", data);
      setSkills(updatedSkills);
    } catch (err) {
      console.error("Update skills failed:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleEditSkillClick = () => {
    setNewSkill(skills.join(", "));
    setEditSkillData(true);
    setEditSkillIndex(null);
    setShowSkillModal(true);
  };

  const handleDeleteSkillClick = async (index) => {
    await handleUpdateSkills([]);
    setSkills([]);
  };

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const url = !id
          ? `${BASE_URL}/user/portfolio/review/`
          : `${BASE_URL}/user/portfolio/check-reviews/?user_id=${id}`;

        const res = await fetch(url, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            "x-api-key": process.env.REACT_APP_X_API_KEY
          },
        });

        if (!res.ok) throw new Error("Failed to fetch reviews");

        const result = await res.json();
        setReviews(result.data || []);
      } catch (error) {
        console.error("Error fetching reviews:", error);
      }
    };

    fetchReviews();
  }, [token, id]);

  useEffect(() => {
    const loadAll = async () => {
      try {
        await Promise.all([
          fetchEducationData(),
          fetchExperiences(),
          fetchInternships(),
          fetchProjects(),
        ]);
      } catch (err) {
        console.error("Error loading portfolio data:", err);
      } finally {
        setLoadingPortfolio(false);
      }
    };
    loadAll();
  }, []);

  // useEffect(() => {
  //   const fetchResume = async () => {
  //     const token = localStorage.getItem("access_token");
  //     try {
  //       let url = null;
  //       if (id) {
  //         url = `${BASE_URL}/user/profile/all-profiles?id=${id}`;
  //       } else {
  //         url = `${BASE_URL}/user/portfolio/personal-portfolio/`;
  //       }

  //       const response = await axios.get(url, {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //         },
  //       });
  //       const data = response.data.data?.[0];
  //       if (!data?.cv_pdf) {
  //         setResumeFile(null);
  //       } else {
  //         setResumeFile({
  //           name: data.cv_pdf.split("/").pop(),
  //           url: data.cv_pdf,
  //         });
  //       }
  //     } catch (error) {
  //       if (
  //         error.response?.data?.message ===
  //         "You don't have a portfolio created Yet"
  //       ) {
  //         setResumeFile(null);
  //       } else {
  //         console.error("Failed to fetch resume:", error);
  //       }
  //     }
  //   };
  //   fetchResume();
  // }, []);

  useEffect(() => {
    const fetchResume = async () => {
      const token = localStorage.getItem("access_token");
      try {
        let url;
        if (id) {
          url = `${BASE_URL}/user/profile/all-profiles?id=${id}`;
        } else {
          url = `${BASE_URL}/user/portfolio/personal-portfolio/`;
        }
        const response = await axios.get(url, {
          headers: { Authorization: `Bearer ${token}`,"x-api-key": process.env.REACT_APP_X_API_KEY },
        });
        let cvUrl;
        if (id) {
          const data = response.data.data;
          cvUrl = data?.portfolio?.cv_pdf;
        } else {
          const data = response.data.data?.[0];
          cvUrl = data?.cv_pdf;
        }

        if (!cvUrl) {
          setResumeFile(null);
        } else {
          setResumeFile({
            name: cvUrl.split("/").pop(),
            url: cvUrl,
          });
        }

        const portfolioData = id
          ? response.data.data?.portfolio
          : response.data.data?.[0];

        setLanguages(
          portfolioData?.language
            ? portfolioData.language.split(",").map((l) => l.trim())
            : []
        );

        setSkills(
          portfolioData?.skills
            ? portfolioData.skills.split(",").map((s) => s.trim())
            : []
        );
      } catch (error) {
        if (
          error.response?.data?.message ===
          "You don't have a portfolio created Yet"
        ) {
          setResumeFile(null);
        } else {
          console.error("Failed to fetch resume:", error);
        }
      }
    };

    fetchResume();
  }, [id]);

  const handleRemoveCV = async () => {
    const token = localStorage.getItem("access_token");
    const formData = new FormData();
    formData.append("cv_pdf", "");
    try {
      await axios.patch(
        `${BASE_URL}/user/portfolio/personal-portfolio/`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
            "x-api-key": process.env.REACT_APP_X_API_KEY
          },
        }
      );
      setResumeFile(null);
    } catch (error) {
      console.error("Failed to delete resume:", error);
    }
  };

  const handleRemoveEducation = async (index) => {
    const educationToDelete = educationList[index];
    const token = localStorage.getItem("access_token");
    try {
      await axios.delete(`${BASE_URL}/user/portfolio/education/`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "x-api-key": process.env.REACT_APP_X_API_KEY
        },
        data: { id: educationToDelete.id },
      });
      await fetchEducationData();
    } catch (error) {
      console.error("Error deleting education:", error.response?.data || error);
    }
  };

  const handleRemoveInternship = async (index) => {
    const internshipToDelete = internships[index];
    const token = localStorage.getItem("access_token");
    try {
      await axios.delete(`${BASE_URL}/user/portfolio/internship/`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "x-api-key": process.env.REACT_APP_X_API_KEY
        },
        data: { id: internshipToDelete.id },
      });
      await fetchInternships();
    } catch (error) {
      console.error(
        "Error deleting internship:",
        error.response?.data || error
      );
    }
  };

  const handleRemoveExperience = async (index) => {
    const experienceToDelete = experiences[index];
    const token = localStorage.getItem("access_token");
    try {
      await axios.delete(`${BASE_URL}/user/portfolio/experience/`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "x-api-key": process.env.REACT_APP_X_API_KEY
        },
        data: { id: experienceToDelete.id },
      });
      await fetchExperiences();
    } catch (error) {
      console.error(
        "Error deleting experience:",
        error.response?.data || error
      );
    }
  };

  const handleRemoveProject = async (index) => {
    const projectToDelete = projects[index];
    const token = localStorage.getItem("access_token");
    try {
      await axios.delete(`${BASE_URL}/user/portfolio/projects/`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "x-api-key": process.env.REACT_APP_X_API_KEY
        },
        data: { id: projectToDelete.id },
      });
      setProjects((prev) => prev.filter((_, i) => i !== index));
      toast.success("Project removed successfully");
    } catch (error) {
      console.error("Error deleting project:", error.response?.data || error);
    }
  };

  // const fetchEducationData = async () => {
  //   try {
  //     const token = localStorage.getItem("access_token");
  //     let url = null;
  //     if (id) {
  //       url = `${BASE_URL}/user/profile/all-profiles?id=${id}`;
  //       setEducationList(res.data.data?.[0]?.education || []);
  //     } else {
  //       url = `${BASE_URL}/user/portfolio/education/`;
  //       setEducationList(res.data.data || []);
  //     }
  //     const res = await axios.get(url, {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //       },
  //     });
  //     console.log("Fetched education data:", res.data);
  //   } catch (error) {
  //     console.error(
  //       "Error fetching education data:",
  //       error.response?.data || error
  //     );
  //   }
  // };

  const fetchEducationData = async () => {
    try {
      const token = localStorage.getItem("access_token");
      let url = id
        ? `${BASE_URL}/user/profile/all-profiles?id=${id}`
        : `${BASE_URL}/user/portfolio/education/`;

      const res = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
          "x-api-key": process.env.REACT_APP_X_API_KEY
        },
      });
      console.log("Fetched education data:", res.data);
      if (id) {
        const education = res.data.data?.education || [];
        setEducationList(education);
      } else {
        const education = res.data.data || [];
        setEducationList(education);
      }
    } catch (error) {
      console.error(
        "Error fetching education data:",
        error.response?.data || error
      );
    }
  };

  useEffect(() => {
    fetchEducationData();
  }, []);

  // const fetchInternships = async () => {
  //   const token = localStorage.getItem("access_token");
  //   try {
  //     let url = null;
  //     if (id) {
  //       url = `${BASE_URL}/user/profile/all-profiles?id=${id}`;
  //     } else {
  //       url = `${BASE_URL}/user/portfolio/internship/`;
  //     }
  //     const response = await fetch(url, {
  //       method: "GET",
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //       },
  //     });
  //     if (!response.ok) {
  //       throw new Error("Failed to fetch internships");
  //     }
  //     const result = await response.json();
  //     if (id) {
  //       const internshipsFromProfile =
  //         result.data?.[0]?.internship || result.data?.[0]?.internships || [];
  //       setInternships(internshipsFromProfile);
  //     } else {
  //       setInternships(result.data || []);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching internships:", error);
  //   }
  // };
  const fetchInternships = async () => {
    const token = localStorage.getItem("access_token");
    try {
      let url = id
        ? `${BASE_URL}/user/profile/all-profiles?id=${id}`
        : `${BASE_URL}/user/portfolio/internship/`;
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "x-api-key": process.env.REACT_APP_X_API_KEY
        },
      });
      if (!response.ok) throw new Error("Failed to fetch internships");
      const result = await response.json();
      if (id) {
        const internshipsFromProfile = result.data?.internships || []; // Adjust the key if needed
        setInternships(internshipsFromProfile);
      } else {
        setInternships(result.data || []);
      }
    } catch (error) {
      console.error("Error fetching internships:", error);
    }
  };

  useEffect(() => {
    fetchInternships();
  }, []);

  const handleAddInternship = () => {
    setShowInternshipForm(true);
  };
  const handleEditInternship = (internship) => {
    setEditingInternship(internship);
    setShowInternshipForm(true);
  };

  const handleAddEducation = async (formData) => {
    const token = localStorage.getItem("access_token");
    const payload = buildEducationPayload(formData);
    try {
      const res = await axios.post(
        `${BASE_URL}/user/portfolio/education/`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "x-api-key": process.env.REACT_APP_X_API_KEY
          },
        }
      );
      console.log("Education added:", res.data);
    } catch (error) {
      console.error("Error adding education:", error);
    }
  };
  const handleEditEducation = async (educationId, formData) => {
    const token = localStorage.getItem("access_token");
    const payload = buildEducationPayload(formData);
    payload.append("id", educationId);
    try {
      const res = await axios.patch(
        `${BASE_URL}/user/portfolio/education/`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
            "x-api-key": process.env.REACT_APP_X_API_KEY
          },
        }
      );
      console.log("Education updated:", res.data);
    } catch (error) {
      console.error("Error updating education:", error);
    }
  };
  // const fetchExperiences = async () => {
  //   const token = localStorage.getItem("access_token");
  //   try {
  //     let url = null;
  //     if (id) {
  //       url = `${BASE_URL}/user/profile/all-profiles?id=${id}`;
  //     } else {
  //       url = `${BASE_URL}/user/portfolio/experience/`;
  //     }
  //     const response = await fetch(url, {
  //       method: "GET",
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //       },
  //     });
  //     if (!response.ok) {
  //       throw new Error("Failed to fetch experiences");
  //     }
  //     const result = await response.json();
  //     // const formattedExperiences = result?.data || result;
  //     // setExperiences(formattedExperiences);
  //     if (id) {
  //       const experiencesFromProfile =
  //         result.data?.[0]?.experience || result.data?.[0]?.experiences || [];
  //       setExperiences(experiencesFromProfile);
  //     } else {
  //       setExperiences(result.data || []);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching experiences:", error);
  //   }
  // };
  const fetchExperiences = async () => {
    const token = localStorage.getItem("access_token");
    try {
      const url = id
        ? `${BASE_URL}/user/profile/all-profiles?id=${id}`
        : `${BASE_URL}/user/portfolio/experience/`;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "x-api-key": process.env.REACT_APP_X_API_KEY
        },
      });
      if (!response.ok) throw new Error("Failed to fetch experiences");
      const result = await response.json();
      if (id) {
        const experiencesFromProfile = result.data?.experiences || [];
        setExperiences(experiencesFromProfile);
      } else {
        setExperiences(result.data || []);
      }
    } catch (error) {
      console.error("Error fetching experiences:", error);
    }
  };

  useEffect(() => {
    fetchExperiences();
  }, []);

  const handleViewCV = () => {
    if (resumeFile?.url) {
      setCvUrl(resumeFile.url);
      setShowCV(true);
    } else {
      console.error("CV not found");
    }
  };

  // const fetchProjects = async (setProjects) => {
  //   const token = localStorage.getItem("access_token");
  //   try {
  //     let url = null;
  //     if (id) {
  //       url = `${BASE_URL}/user/profile/all-profiles?id=${id}`;
  //     } else {
  //       url = `${BASE_URL}/user/portfolio/projects/`;
  //     }
  //     const response = await fetch(url, {
  //       method: "GET",
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //       },
  //     });
  //     if (!response.ok) {
  //       throw new Error("Failed to fetch projects");
  //     }
  //     const result = await response.json();
  //     // const formattedProjects = result?.data || result;
  //     // setProjects(formattedProjects);
  //     if (id) {
  //       const projectsFromProfile = result.data?.[0]?.projects || [];
  //       setProjects(projectsFromProfile);
  //     } else {
  //       setProjects(result.data || []);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching projects:", error);
  //   }
  // };
  const fetchProjects = async (setProjects) => {
    const token = localStorage.getItem("access_token");
    try {
      const url = id
        ? `${BASE_URL}/user/profile/all-profiles?id=${id}`
        : `${BASE_URL}/user/portfolio/projects/`;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "x-api-key": process.env.REACT_APP_X_API_KEY
        },
      });
      if (!response.ok) throw new Error("Failed to fetch projects");
      const result = await response.json();
      if (id) {
        const projectsFromProfile = result.data?.projects || [];
        setProjects(projectsFromProfile);
      } else {
        setProjects(result.data || []);
      }
    } catch (error) {
      console.error("Error fetching projects:", error);
    }
  };

  useEffect(() => {
    fetchProjects(setProjects);
  }, []);

  const handleEditProject = (project) => {
    setEditingProjectData(project);
    setShowProjectForm(true);
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setShowCV(false);
      }
    }

    if (showCV) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showCV]);

  return (
    <>
      <div className="w-full">
        {loadingPortfolio ? (
          <div className="flex justify-center items-center min-h-[200px]">
            <ClipLoader color="#4A90E2" size={50} />
          </div>
        ) : (
          <>
            <div className="w-full max-w-[1024px] mx-auto flex flex-col gap-5 mt-5 rounded-xl">
              <div className="bg-white rounded-2xl p-2 md:p-6 shadow-lg">
  {/* Header */}
  <div className=" relative flex items-center justify-between mb-6">
    <div className="flex items-center gap-3">
      <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
        <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
      </div>
      <div>
        <h3 className="text-lg font-bold text-gray-900" style={{whiteSpace:'nowrap'}}>Personal Portfolio (CV)</h3>
        {/* <p className="text-sm text-gray-500 mt-0.5">Upload your resume or CV</p> */}
      </div>
    </div>

    <div className="absolute top-[-25px] right-0">
       {!id && (
      <DropdownActions
        onEdit={() => fileInputRef.current.click()}
        onDelete={handleRemoveCV}
      />
    )}
    </div>
  </div>

  {/* Upload Area */}
  <div className="border-2 border-dashed border-slate-300 bg-slate-50 rounded-2xl p-8 text-center">
    {resumeFile ? (
      <div className="flex flex-col items-center gap-4">
        <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center">
          <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <div className="text-center">
          <p className="text-sm font-medium text-gray-900 mb-1">File Uploaded</p>
          <p className="text-sm text-gray-500 truncate max-w-xs">{resumeFile.name}</p>
        </div>
        <button
          onClick={handleViewCV}
          className="px-5 py-2.5 bg-[#0f6abf] text-white text-sm font-medium rounded-xl hover:bg-[#0a5ca8] transition-colors flex items-center gap-2"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
          </svg>
          View CV
        </button>
      </div>
    ) : !id ? (
      <div className="flex flex-col items-center gap-4">
        {isUploading ? (
          <div className="flex flex-col items-center gap-3">
            <div className="w-8 h-8 border-2 border-[#0f6abf] border-t-transparent rounded-full animate-spin"></div>
            <p className="text-sm text-gray-500">Uploading...</p>
          </div>
        ) : (
          <>
            <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center">
              <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M9 19l3 3m0 0l3-3m-3 3V10" />
              </svg>
            </div>
            <div className="text-center">
              <p className="text-sm font-medium text-gray-900 mb-1">Upload your CV</p>
              <p className="text-sm text-gray-500">PDF files only</p>
            </div>
            <button
              onClick={() => fileInputRef.current.click()}
              className="w-12 h-12 bg-[#0f6abf] text-white rounded-xl flex items-center justify-center hover:bg-[#0a5ca8] transition-colors"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
              </svg>
            </button>
          </>
        )}
      </div>
    ) : (
      <div className="flex flex-col items-center gap-4">
        <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center">
          <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
        </div>
        <div className="text-center">
          <p className="text-sm font-medium text-gray-900">No portfolio added</p>
          <p className="text-sm text-gray-500">This user hasn't uploaded a CV yet</p>
        </div>
      </div>
    )}

    <input
      type="file"
      ref={fileInputRef}
      accept="application/pdf"
      onChange={handleResumeUpload}
      className="hidden"
    />
  </div>
</div>

              <div className="flex flex-col gap-5">
                {/* Experience section */}
                <div className="rounded-lg p-2 md:p-6 bg-white w-full shadow-[0_6px_20px_rgba(0,0,0,0.08)]">
                  <div className="mb-5 w-full max-w-[1050px] bg-slate-50 py-6 px-3 md:px-6 rounded-[10px] flex justify-between">
                    <h3 className="text-xl font-bold">Professioanl Experience</h3>
                    {!id && (
                      <div className="ml-4 shrink-0 bg-[#004182] text-white p-3 rounded-full font-medium cursor-pointer border border-[#00449d] flex items-center justify-center">
                        <button
                          onClick={() => setShowExpModal(true)}
                          title="Add">
                          <Plus size={18} />
                        </button>
                      </div>
                    )}
                  </div>
                 {experiences.length === 0 && (
  <div className="flex flex-col gap-2">
    <div className="p-4 flex flex-col gap-2 bg-white rounded-xl border border-gray-200 shadow-sm min-h-[150px]">
      <div className="flex flex-col">
        <h4 className="text-base font-semibold text-gray-900">Job Title</h4>
        <p className="text-sm text-gray-500 font-medium">Organization</p>
        <p className="text-sm text-gray-500 font-medium">2023 - present</p>
      </div>
    </div>
  </div>
)}

{experiences?.filter(Boolean).map((exp, idx) => (
  <div key={idx} className="relative p-6 bg-white rounded-xl border border-gray-200 shadow-sm">
    
    {/* Edit/Delete */}
    {!id && (
      <div className="absolute top-[-15px] right-2">
        <DropdownActions
          onEdit={() => {
            setEditExperienceIndex(idx);
            setEditExperienceData(exp);
            setShowExpModal(true);
          }}
          onDelete={() => handleRemoveExperience(idx)}
        />
      </div>
    )}

    {/* Experience Details */}
    <div className="space-y-3">
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center flex-shrink-0">
          <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
          </svg>
        </div>
        <div>
          <h4 className="text-base font-semibold text-gray-900">{exp.title}</h4>
          <p className="text-sm text-gray-600">
            {exp.company} — {exp.employment_type}
          </p>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4 pl-13">
        <div className="flex items-center gap-2">
          <svg className="w-4 h-4 text-gray-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
          </svg>
          <span className="text-sm text-gray-600">
            {exp?.start_month && exp?.start_year
              ? `${exp.start_month} ${exp.start_year} - ${exp.is_current
                  ? "Present"
                  : `${exp.end_month || ""} ${exp.end_year || ""}`}`
              : "Duration not specified"}
          </span>
        </div>

        <div className="flex items-center gap-2">
          <svg className="w-4 h-4 text-gray-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
          </svg>
          <span className="text-sm text-gray-600">
            {exp.location} ({exp.location_type})
          </span>
        </div>
      </div>

      {exp.description && (
        <div className="pl-13">
          <p className="text-sm text-gray-700 leading-relaxed">{exp.description}</p>
        </div>
      )}

      {exp.skills && (
  <div className="pl-13 mt-2">
    <div className="flex items-center gap-2 mb-2">
      <svg
        className="w-4 h-4 text-gray-500 flex-shrink-0"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
        />
      </svg>
      <span className="text-sm font-medium text-gray-700">Skills</span>
    </div>

    <div className="flex flex-wrap gap-2">
      {typeof exp.skills === "string"
        ? exp.skills.split(",").map((skill, i) => (
            <span
              key={i}
              className="px-3 py-1 bg-slate-100 text-gray-700 text-xs rounded-lg"
            >
              {skill.trim()}
            </span>
          ))
        : Array.isArray(exp.skills)
        ? exp.skills.map((skill, i) => (
            <span
              key={i}
              className="px-3 py-1 bg-slate-100 text-gray-700 text-xs rounded-lg"
            >
              {skill}
            </span>
          ))
        : null}
    </div>
  </div>
)}


      {exp.media && (
        <div className="pl-13">
          <div className="flex items-center gap-2">
            <svg className="w-4 h-4 text-gray-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
            <a
              href={exp.media}
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#0f6abf] hover:underline text-sm font-medium"
            >
              View Media
            </a>
          </div>
        </div>
      )}
    </div>
  </div>
))}
                </div>
                {/* Internship section */}
                <div className="rounded-lg p-2 md:p-6 bg-white w-full shadow-[0_6px_20px_rgba(0,0,0,0.08)]">
                  <div className="mb-5 w-full max-w-[1050px] bg-slate-50 py-6 px-3 md:px-6 rounded-[10px] flex justify-between">
                    <h3 className="text-xl font-bold">Internships</h3>
                    {!id && (
                      <div className="ml-4 shrink-0 bg-[#004182] text-white p-3 rounded-full font-medium cursor-pointer border border-[#00449d] flex items-center justify-center">
                        <button
                          onClick={() => setShowInternshipForm(true)}
                          title="Add"
                        >
                          <Plus size={18} />
                        </button>
                      </div>
                    )}
                  </div>
                  {/* Internship Card Placeholder */}
                <div className="space-y-4">
  {internships.length === 0 && (
    <div className="p-6 bg-gray-50 border-2 border-dashed border-gray-300 rounded-xl text-center">
      <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-3">
        <svg className="w-6 h-6 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
        </svg>
      </div>
      <h4 className="text-base font-semibold text-gray-900 mb-1">No internships added</h4>
      <p className="text-sm text-gray-500">Add your internship experience</p>
    </div>
  )}

  {internships.map((internship, index) => (
    <div
      key={index}
      className="relative p-6 bg-white rounded-xl border border-gray-200 shadow-sm"
    >
      {/* Header with Actions */}
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1">
          <div className="flex items-center gap-3 mb-2">
            <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
              <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
            </div>
            <div>
              <h3 className="text-lg font-semibold text-gray-900">
                {internship.title} at {internship.company}
              </h3>
              <div className="flex items-center gap-3 mt-1">
                <div className="flex items-center gap-1 text-sm text-gray-500">
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                  </svg>
                  <span>{internship.start_month} {internship.start_year} - {
                    internship.currently_working
                      ? "Present"
                      : `${internship.end_month || ""} ${internship.end_year || ""}`
                  }</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        {!id && (
          <div className="absolute top-[-15px] right-2">
            <DropdownActions
              onEdit={() => {
                setEditingInternship(internship);
                setShowInternshipForm(true);
              }}
              onDelete={() => handleRemoveInternship(index)}
            />
          </div>
        )}
      </div>

      {/* Description */}
      {internship.description && (
        <div className="mb-4">
          <p className="text-sm text-gray-700">{internship.description}</p>
        </div>
      )}

      {/* Details Grid */}
      <div className="grid grid-cols-2 gap-4 mt-4 pt-4 border-t border-gray-100">
        {/* Skills */}
        {internship.skills && (
          <div>
            <div className="flex items-center gap-2 mb-2">
              <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
              </svg>
              <p className="text-sm font-medium text-gray-700">Skills</p>
            </div>
            <div className="flex flex-wrap gap-2">
              {(Array.isArray(internship.skills) ? internship.skills : internship.skills.split(",").map(s => s.trim())).map((skill, i) => (
                <span key={i} className="px-3 py-1 bg-gray-100 text-gray-700 text-xs font-medium rounded-lg">
                  {skill}
                </span>
              ))}
            </div>
          </div>
        )}

        {/* Location */}
        {internship.location && internship.location_type && (
          <div>
            <div className="flex items-center gap-2 mb-2">
              <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
              <p className="text-sm font-medium text-gray-700">Location</p>
            </div>
            <p className="text-sm text-gray-700">{internship.location} ({internship.location_type})</p>
          </div>
        )}

        {/* Media Link */}
        {internship.media && (
          <div className="col-span-2">
            <a
              href={internship.media}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-4 py-2 bg-gray-50 text-[#0f6abf] text-sm font-medium rounded-lg hover:bg-gray-100 transition-colors"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
              </svg>
              View Internship Media
            </a>
          </div>
        )}
      </div>
    </div>
  ))}
</div>
                  {/* Add Internship Button */}
                </div>
                {/* edudation section */}
               <div className="bg-white rounded-2xl p-2 md:p-6 shadow-sm border border-gray-200">
  {/* Header */}
  <div className="flex items-center justify-between ">
   
      <div className="mb-5 w-full max-w-[1050px] bg-slate-50 py-6 px-3 md:px-6 rounded-[10px] flex justify-between">
                    <div className="flex items-center gap-3">
      <h3 className="text-lg font-semibold text-gray-900">Education</h3>
    </div>
                    {!id && (
                      <div className="ml-4 shrink-0 bg-[#004182] text-white p-3 rounded-full font-medium cursor-pointer border border-[#00449d] flex items-center justify-center">
                        <button
                          onClick={() => setEducationModalOpen(true)}
                          title="Add"
                        >
                          <Plus size={18} />
                        </button>
                      </div>
                    )}
                  </div>
   
  </div>

  {/* Empty State */}
  {educationList.length === 0 && (
    <div className="border-2 border-dashed border-gray-300 rounded-2xl p-8 text-center">
      <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
        <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 14l9-5-9-5-9 5 9 5z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 14l9-5-9-5-9 5 9 5z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 14l9-5-9-5-9 5 9 5z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 14l9-5-9-5-9 5 9 5z" />
        </svg>
      </div>
      <h4 className="text-lg font-medium text-gray-700 mb-2">Add your education</h4>
      <p className="text-sm text-gray-500 mb-2">School, Degree, Field of study</p>
      <p className="text-sm text-gray-500">2019 - 2023</p>
    </div>
  )}

  {/* Education List */}
  <div className="space-y-4">
    {educationList.map((edu, index) => (
      <div
        key={index}
        className="relative p-6 bg-white rounded-xl border border-gray-200 shadow-sm"
      >
        {/* Edit/Delete Actions */}
        {!id && (
          <div className="absolute top-[-15px] right-2">
            <DropdownActions
              onEdit={() => {
                setEditingEducationData(edu);
                setEducationModalOpen(true);
              }}
              onDelete={() => handleRemoveEducation(index)}
            />
          </div>
        )}

        {/* School */}
        <div className="flex items-center gap-2 mb-2">
          <svg className="w-4 h-4 text-gray-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
          </svg>
          <h4 className="text-base font-semibold text-gray-900">{edu.school}</h4>
        </div>

        {/* Degree & Field */}
        <div className="flex items-center gap-2 mb-2">
          <svg className="w-4 h-4 text-gray-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <p className="text-sm text-gray-600">
            {edu.degree}, {edu.field_study}
          </p>
        </div>

        {/* Duration */}
        <div className="flex items-center gap-2 mb-2">
          <svg className="w-4 h-4 text-gray-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
          </svg>
          <p className="text-sm text-gray-600">
            {edu.start_Year} - {edu.end_Year}
          </p>
        </div>

        {/* Grade */}
        <div className="flex items-center gap-2 mb-3">
          <svg className="w-4 h-4 text-gray-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
          </svg>
          <p className="text-sm text-gray-600">Grade: {edu.grade}</p>
        </div>

        {/* Description */}
        {edu.description && (
          <div className="mb-3">
            <p className="text-sm text-gray-700">{edu.description}</p>
          </div>
        )}

        {/* Skills */}
        {edu.skills?.length > 0 && (
          <div className="mb-3">
            <div className="flex flex-wrap gap-2">
              <span className="text-xs font-medium text-gray-500">Skills:</span>
              {Array.isArray(edu.skills)
                ? edu.skills.map((skill, i) => (
                    <span key={i} className="text-xs px-2 py-1 bg-slate-100 text-gray-700 rounded-lg">
                      {skill}
                    </span>
                  ))
                : <span className="text-sm text-gray-600">{edu.skills}</span>}
            </div>
          </div>
        )}

        {/* Media */}
        {edu.media && typeof edu.media === "string" && (
          <div className="flex items-center gap-2 pt-3 border-t border-gray-200">
            <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
            <a
              href={edu.media}
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-[#0f6abf] hover:underline"
            >
              View Media
            </a>
          </div>
        )}
      </div>
    ))}
  </div>
</div>
                {/* Language section */}
                <div className="rounded-lg p-2 md:p-6 bg-white w-full shadow-[0_6px_20px_rgba(0,0,0,0.08)]">
                   {/* Header */}
  <div className="flex items-center justify-between ">
   
      <div className="mb-5 w-full max-w-[1050px] bg-slate-50 py-6 px-3 md:px-6 rounded-[10px] flex justify-between">
                    <div className="flex items-center gap-3">
      <h3 className="text-lg font-semibold text-gray-900">Languages</h3>
    </div>
                    {!id && (
                      <div className="ml-4 shrink-0 bg-[#004182] text-white p-3 rounded-full font-medium cursor-pointer border border-[#00449d] flex items-center justify-center">
                        <button
                          onClick={() => setShowLanguageModal(true)}
                          title="Add"
                        >
                          <Plus size={18} />
                        </button>
                      </div>
                    )}
                  </div>
   
  </div>
                 
                <div className="relative space-y-4">
  {/* Header with Actions */}
  {!id && languages.length > 0 && (
    <div className="flex justify-end">
      <div className="absolute top-[-15px] right-2">
        <DropdownActions
          onEdit={() => handleEditClick()}
          onDelete={() => handleDeleteClick()}
        />
      </div>
    </div>
  )}

  {/* Languages List */}
  {languages.length > 0 ? (
    <div className="flex flex-wrap gap-2">
      {languages.map((lang, index) => (
        <div
          key={index}
          className="flex items-center gap-2 px-3 py-2 bg-gray-50 border border-gray-200 rounded-xl"
        >
          <div className="w-6 h-6 bg-white rounded-lg flex items-center justify-center">
            <svg className="w-3 h-3 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129" />
            </svg>
          </div>
          <span className="text-sm text-gray-900">{lang}</span>
        </div>
      ))}
    </div>
  ) : (
    <div className="border-2 border-dashed border-gray-300 rounded-2xl p-8 text-center">
      <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
        <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129" />
        </svg>
      </div>
      <p className="text-sm text-gray-500">No languages added yet.</p>
    </div>
  )}
</div>
                </div>

                {/* skills section */}
                <div className="rounded-lg p-2 md:p-6 bg-white w-full shadow-[0_6px_20px_rgba(0,0,0,0.08)]">
                   <div className="flex items-center justify-between ">
   
      <div className="mb-5 w-full max-w-[1050px] bg-slate-50 py-6 px-3 md:px-6 rounded-[10px] flex justify-between">
                    <div className="flex items-center gap-3">
      <h3 className="text-lg font-semibold text-gray-900">Skills</h3>
    </div>
                    {!id && (
                      <div className="ml-4 shrink-0 bg-[#004182] text-white p-3 rounded-full font-medium cursor-pointer border border-[#00449d] flex items-center justify-center">
                        <button
                          onClick={() => setShowSkillModal(true)}
                          title="Add"
                        >
                          <Plus size={18} />
                        </button>
                      </div>
                    )}
                  </div>
   
  </div>
                 
                  <div className="space-y-4">
  <div className="flex justify-end">
    {!id && skills.length > 0 && (
      <DropdownActions
        onEdit={() => handleEditSkillClick()}
        onDelete={() => handleDeleteSkillClick()}
      />
    )}
  </div>

  {skills.length > 0 ? (
    <div className="flex flex-wrap gap-2">
      {skills.map((skill, index) => (
        <div
          key={index}
          className="flex items-center gap-2 px-3 py-2 bg-[#e8f0f7] text-[#0f6abf] rounded-xl text-sm font-medium"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
          </svg>
          <span>{skill}</span>
        </div>
      ))}
    </div>
  ) : (
    <div className="text-center py-6">
      <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-3">
        <svg className="w-6 h-6 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
        </svg>
      </div>
      <p className="text-sm text-gray-500">No skills added yet.</p>
    </div>
  )}
</div>
                </div>

                {/* Reviewer*/}
                <div className="rounded-lg p-2 md:p-6 bg-white w-full shadow-[0_6px_20px_rgba(0,0,0,0.08)]">
                     <div className="flex items-center justify-between ">
   
      <div className="mb-5 w-full max-w-[1050px] bg-slate-50 py-6 px-3 md:px-6 rounded-[10px] flex justify-between">
                    <div className="flex items-center gap-3">
      <h3 className="text-lg font-semibold text-gray-900">Reviewer</h3>
    </div>
                    {!id && (
                      <div className="ml-4 shrink-0 bg-[#004182] text-white p-3 rounded-full font-medium cursor-pointer border border-[#00449d] flex items-center justify-center">
                        <button
                          onClick={() => setshowReviewModal(true)}
                          title="Add"
                        >
                          <Plus size={18} />
                        </button>
                      </div>
                    )}
                  </div>
   
  </div>
                  
                 <div className="relative space-y-4">
  <div className="absolute top-[-15px] right-2">
    {!id && (
      <DropdownActions
        onEdit={() => handleEdit()}
        onDelete={() => handleDeleteReview()}
      />
    )}
  </div>

  {reviews.length > 0 ? (
    <div className="space-y-3">
      {reviews.map((review, index) => (
        <div
          key={index}
          className="flex items-center justify-between p-4 bg-slate-50 rounded-xl border border-slate-200"
        >
          <div className="flex items-center gap-3">
            <div className="w-2 h-2 bg-[#0f6abf] rounded-full"></div>
            <span className="text-sm text-gray-700">{review.review}</span>
          </div>
        </div>
      ))}
    </div>
  ) : (
    <div className="text-center py-8 border-2 border-dashed border-gray-300 rounded-xl">
      <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-3">
        <svg className="w-6 h-6 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
      </div>
      <p className="text-sm text-gray-500">No reviews added yet.</p>
    </div>
  )}
</div>
                </div>

                {/* Personal Projects */}
                <div className="section-container">
                  <div className="personal-projects-section">
                      <div className="flex items-center justify-between ">
   
      <div className="mb-5 w-full max-w-[1050px] bg-slate-50 py-6 px-3 md:px-6 rounded-[10px] flex justify-between">
                    <div className="flex items-center gap-3">
      <h3 className="text-lg font-semibold text-gray-900">Projects</h3>
    </div>
                    {!id && (
                      <div className="ml-4 shrink-0 bg-[#004182] text-white p-3 rounded-full font-medium cursor-pointer border border-[#00449d] flex items-center justify-center">
                        <button
                          onClick={() => setShowProjectForm(true)}
                          title="Add"
                        >
                          <Plus size={18} />
                        </button>
                      </div>
                    )}
                  </div>
   
  </div>
                    {" "}
                    <p className="text-[15px] font-medium leading-[23px] mb-[10px]">
                      Showcase your work, tech stack, and key achievements.
                    </p>
                    <div className="flex flex-col gap-4 md:grid md:grid-cols-1">
                      {/* Project Card */}
                     {projects.length === 0 && (
  <div className="flex flex-col justify-center items-center py-12 bg-white rounded-xl border border-gray-200">
    <div className="w-16 h-16 bg-[#e8f0f7] rounded-xl flex items-center justify-center mb-4">
      <svg 
        className="w-8 h-8 text-[#0f6abf]" 
        fill="none" 
        stroke="currentColor" 
        viewBox="0 0 24 24" 
        xmlns="http://www.w3.org/2000/svg"
      >
        <path 
          strokeLinecap="round" 
          strokeLinejoin="round" 
          strokeWidth="2" 
          d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" 
        />
      </svg>
    </div>
    <h3 className="text-lg font-semibold text-gray-900 mb-2">No projects yet</h3>
    <p className="text-gray-500 text-sm mb-4">Create your first project to showcase your work</p>
  </div>
)}

                     {projects.map((project, idx) => (
  <div
    key={idx}
    className="
      bg-white border border-gray-200 rounded-xl shadow-sm
      p-6 mb-6
      flex flex-col gap-3
      transition-all duration-200
      hover:shadow-md
    "
  >
    {/* Actions */}
    {!id && (
      <div className="flex justify-end">
        <DropdownActions
          onEdit={() => {
            setEditingProjectIndex(idx);
            setEditingProjectData(project);
            setShowProjectForm(true);
          }}
          onDelete={() => handleRemoveProject(idx)}
        />
      </div>
    )}

    {/* Project Name */}
    <div className="flex items-center gap-2">
      <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
      <h4 className="text-lg font-semibold text-gray-900">
        {project.project_name}
      </h4>
    </div>

    {/* Skills */}
    {project.skills && (
      <div className="flex flex-wrap gap-2 mt-1">
        {Array.isArray(project.skills)
          ? project.skills.map((skill, skillIdx) => (
              <span
                key={skillIdx}
                className="text-xs px-3 py-1 bg-[#e8f0f7] text-[#0f6abf] rounded-lg font-medium"
              >
                {skill}
              </span>
            ))
          : (
              <span className="text-xs px-3 py-1 bg-[#e8f0f7] text-[#0f6abf] rounded-lg font-medium">
                {project.skills}
              </span>
            )}
      </div>
    )}

    {/* Description */}
    {project.description && (
      <p className="text-sm text-gray-700 leading-relaxed mt-2">
        {project.description}
      </p>
    )}

    {/* Duration */}
    <div className="flex items-center gap-2 text-sm text-gray-500 mt-3">
      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
      </svg>
      <span>
        {project.start_month} {project.start_year} –{" "}
        {project.is_current
          ? "Present"
          : project.end_month && project.end_year
          ? `${project.end_month} ${project.end_year}`
          : ""}
      </span>
    </div>

    {/* Media */}
    {project.media && typeof project.media === "string" && (
      <div className="flex items-center gap-3 mt-4 p-3 bg-gray-50 rounded-lg">
        <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
        </svg>
        <div>
          <p className="text-xs text-gray-500">Media</p>
          <a
            href={project.media}
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-[#0f6abf] font-medium hover:underline"
          >
            View Media
          </a>
        </div>
      </div>
    )}
  </div>
))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>

      {/* Modals */}

      {showExpModal && (
        <Modal
          isOpen={showExpModal}
          onClose={() => {
            setShowExpModal(false);
            setEditExperienceIndex(null);
            setEditExperienceData(null);
          }}
          title={editExperienceData ? "Edit Experience" : "Add Experience"}
        >
          <ExperienceForm
            onClose={() => {
              setShowExpModal(false);
              setEditExperienceIndex(null);
              setEditExperienceData(null);
            }}
            onSave={(updatedData) => {
              if (editExperienceData?.id) {
                setExperiences((prev) =>
                  prev.map((exp) =>
                    exp.id === editExperienceData.id ? updatedData : exp
                  )
                );
              } else {
                setExperiences((prev) => [...prev, updatedData]);
              }
              fetchExperiences();
              setShowExpModal(false);
              setEditExperienceIndex(null);
              setEditExperienceData(null);
            }}
            defaultValues={editExperienceData}
          />
        </Modal>
      )}

      {EducationModalOpen && (
        <Modal
          isOpen={EducationModalOpen}
          onClose={() => setEducationModalOpen(false)}
          closeOnOutsideClick={true}
        >
          <EducationForm
            title={editingEducationData ? "Edit Education" : "Add Education"}
            onClose={() => {
              setEducationModalOpen(false);
              setEditingEducationData(null);
            }}
            onSave={async (formData) => {
              if (editingEducationData) {
                await handleEditEducation(editingEducationData.id, formData);
              } else {
                await handleAddEducation(formData);
              }
              await fetchEducationData();
              setEducationModalOpen(false);
              setEditingEducationData(null);
            }}
            initialData={editingEducationData}
          />
        </Modal>
      )}

      {showProjectForm && (
        <Modal
          isOpen={showProjectForm}
          onClose={() => {
            setShowProjectForm(false);
            setEditingProjectIndex(null);
            setEditingProjectData(null);
          }}
          title={editingProjectIndex !== null ? "Edit Project" : "Add Project"}
          closeOnOutsideClick={true}
        >
          <ProjectForm
            onClose={() => {
              setShowProjectForm(false);
              setEditingProjectData(null);
              fetchProjects();
            }}
            fetchProjects={fetchProjects}
            onSave={(updatedProject) => {
              if (editingProjectData?.id) {
                setProjects((prev) =>
                  prev.map((p) =>
                    p.id === updatedProject.id ? updatedProject : p
                  )
                );
              } else {
                setProjects((prev) => [...prev, updatedProject]);
              }
              setEditingProjectData(null);
            }}
            project={editingProjectData}
          />
        </Modal>
      )}

      {showInternshipForm && (
        <Modal
          isOpen={showInternshipForm}
          onClose={() => setShowInternshipForm(false)}
          title={editingInternship ? "Edit Internship" : "Add Internship"}
        >
          <InternshipForm
            onClose={() => {
              setShowInternshipForm(false);
              setEditingInternship(null);
            }}
            defaultValues={editingInternship}
            onSave={(updatedData) => {
              if (editingInternship?.id) {
                setInternships((prev) =>
                  prev.map((item) =>
                    item.id === editingInternship.id ? updatedData : item
                  )
                );
              } else {
                setInternships((prev) => [...prev, updatedData]);
              }
              setShowInternshipForm(false);
              setEditingInternship(null);
            }}
          />
        </Modal>
      )}

      {showLanguageModal && (
        <Modal
          isOpen={showLanguageModal}
          onClose={() => {
            setShowLanguageModal(false);
            setEditLanguageIndex(null);
            setEditLanguageData(null);
            setNewLanguage("");
          }}
          title={editLanguageData ? "Edit Language" : "Add Language"}
        >
         <div className="w-full px-0 md:px-6">
  <form
    onSubmit={async (e) => {
      e.preventDefault();
      if (!newLanguage.trim()) return;

      const updatedLanguages = editLanguageData
        ? newLanguage
            .split(",")
            .map((l) => l.trim())
            .filter((l) => l)
        : [
            ...languages,
            ...newLanguage
              .split(",")
              .map((l) => l.trim())
              .filter((l) => l && !languages.includes(l)),
          ];

      await handleUpdateLanguage(updatedLanguages);

      setNewLanguage("");
      setShowLanguageModal(false);
      setEditLanguageIndex(null);
      setEditLanguageData(null);
    }}
  >
    {/* Language Field */}
    <div className="mb-6">
      <div className="flex items-center gap-2 mb-3">
        <label className="text-sm font-semibold text-gray-700">
          Language
        </label>
      </div>
      <input
        type="text"
        value={newLanguage}
        onChange={(e) => setNewLanguage(e.target.value)}
        placeholder="e.g. English, Spanish, French"
        className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
      />
      <p className="text-xs text-gray-500 mt-2">Separate multiple languages with commas</p>
    </div>

    {/* Actions */}
    <div className="mt-8 flex justify-end gap-3 pt-6 border-t border-gray-100">
      <button
        type="submit"
        disabled={loading}
        className="px-5 py-2.5 bg-[#0f6abf] text-white text-sm font-medium rounded-xl hover:bg-[#0a5ca8] transition-colors disabled:opacity-50 flex items-center gap-2"
      >
        {loading ? (
          <>
            <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
            Saving...
          </>
        ) : (
          <>
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
            </svg>
            Save Changes
          </>
        )}
      </button>
    </div>
  </form>
</div>
        </Modal>
      )}

      {showSkillModal && (
        <Modal
          isOpen={showSkillModal}
          onClose={() => {
            setShowSkillModal(false);
            setEditSkillIndex(null);
            setEditSkillData(null);
            setNewSkill("");
          }}
          title={editSkillData ? "Edit skills" : "Add Skills"}
        >
       <div className="w-full px-0 md:px-6">
  <form
    onSubmit={async (e) => {
      e.preventDefault();
      if (!newSkill.trim()) return;

      const updatedSkills = editSkillData
        ? newSkill
            .split(",")
            .map((l) => l.trim())
            .filter((l) => l)
        : [
            ...skills,
            ...newSkill
              .split(",")
              .map((l) => l.trim())
              .filter((l) => l && !skills.includes(l)),
          ];

      await handleUpdateSkills(updatedSkills);

      setNewSkill("");
      setShowSkillModal(false);
      setEditSkillIndex(null);
      setEditSkillData(null);
    }}
  >
    {/* Skill Field */}
    <div className="mb-6">
      <div className="flex items-center gap-2 mb-3">
        <label className="text-sm font-semibold text-gray-700">
          Skills
        </label>
      </div>
      <input
        type="text"
        value={newSkill}
        onChange={(e) => setNewSkill(e.target.value)}
        placeholder="Enter skills separated by commas"
        className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
      />
      <p className="text-xs text-gray-500 mt-2">
        e.g. ReactJS, Python, Data Analysis, Academic Writing
      </p>
    </div>

    {/* Actions */}
    <div className="flex justify-end gap-3 pt-6 border-t border-gray-100">
      <button
        type="submit"
        disabled={loading}
        className="px-5 py-2.5 bg-[#0f6abf] text-white text-sm font-medium rounded-xl hover:bg-[#0a5ca8] transition-colors disabled:opacity-50 flex items-center gap-2"
      >
        {loading ? (
          <>
            <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
            Saving...
          </>
        ) : (
          <>
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
            </svg>
            Save Skills
          </>
        )}
      </button>
    </div>
  </form>
</div>
        </Modal>
      )}

      {showReviewModal && (
        <Modal
          isOpen={showReviewModal}
          onClose={() => {
            setshowReviewModal(false);
            setEditReviewIndex(null);
            setEditReviewData(null);
            setNewReview("");
          }}
          title={editReviewData ? "Edit Review" : "Add Review"}
        >
        <div className="w-full px-0 md:px-6">
  <form
    onSubmit={async (e) => {
      e.preventDefault();
      if (!newReview.trim()) return;

      const updatedReviews = newReview
        .split(",")
        .map((r) => ({ review: r.trim() }))
        .filter((r) => r.review !== "");

      if (editReviewData) {
        await handleEditReview(updatedReviews);
      } else {
        await handleAddReview(updatedReviews);
      }
      setNewReview("");
      setshowReviewModal(false);
      setEditReviewIndex(null);
      setEditReviewData(null);
    }}
  >
    {/* Review Field */}
    <div className="mb-6">
      <div className="flex items-center gap-2 mb-3">
        <label className="text-sm font-semibold text-gray-700">
          Reviews
        </label>
      </div>
      <input
        type="text"
        value={newReview}
        onChange={(e) => setNewReview(e.target.value)}
        placeholder="Enter reviews separated by commas"
        className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
      />
      <p className="text-xs text-gray-500 mt-2">Separate multiple reviews with commas</p>
    </div>

    {/* Actions */}
    <div className="flex justify-end gap-3 pt-6 border-t border-gray-100">
      <button
        type="submit"
        disabled={loading}
        className="px-5 py-2.5 bg-[#0f6abf] text-white text-sm font-medium rounded-xl hover:bg-[#0a5ca8] transition-colors disabled:opacity-50 flex items-center gap-2"
      >
        {loading ? (
          <>
            <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
            Saving...
          </>
        ) : (
          <>
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
            </svg>
            Save Review
          </>
        )}
      </button>
    </div>
  </form>
</div>
        </Modal>
      )}
{showCV && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4  pt-[80px]">
    <div
      ref={modalRef}
      className="w-full max-w-4xl  max-h-[90vh] overflow-hidden rounded-2xl bg-white shadow-xl"
    >
      {/* Modal Header */}
      <div className="flex items-center justify-between border-b border-gray-200 p-2 md:p-6">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
            <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
          </div>
          <div>
            <h3 className="text-lg font-semibold text-gray-900">Portfolio CV</h3>
            <p className="text-sm text-gray-500">View document</p>
          </div>
        </div>
        
        <button
          onClick={() => setShowCV(false)}
          className="w-10 h-10 flex items-center justify-center rounded-xl hover:bg-gray-100 transition-colors"
        >
          <svg className="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      {/* Modal Content */}
      <div className="p-2 md:p-6">
        <iframe
          src={cvUrl}
          title="Portfolio CV"
          className="w-full h-[600px] rounded-xl border border-gray-200"
        />
      </div>

      {/* Modal Footer */}
      {/* <div className="border-t border-gray-200 px-6 py-4">
        <button
          onClick={() => setShowCV(false)}
          className="w-full py-2.5 text-gray-700 font-medium rounded-xl hover:bg-gray-100 transition-colors"
        >
          Close
        </button>
      </div> */}
    </div>
  </div>
)}
    </>
  );
};

export default Portfolio;
